const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'UNIDADE_MEDIDA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'UNIDADE_MEDIDA_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

		case 'UNIDADE_MEDIDA_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        default:
            return state;
    }
}
